import React from 'react';
import styled from "@emotion/styled";
import { Slide } from 'react-slideshow-image';;
import "./style/Slideshow/style.scss";
import { RenderContext } from "../Context/Ssr";

const SlideContainer = styled.div`
    background-size:cover;
`;

const Image = styled.img`
    width:100%;
    height:auto;
`;

export class Slideshow extends React.Component {
    constructor(props) {
        super(props);

        this.slideshowRef = React.createRef();
        this.containerRef = React.createRef();
        this.leftArrowRef = React.createRef();
        this.rightArrowRef = React.createRef();

        this.state = {
            originalImages: this.props.images, 
            images: this.images(),
            current: 0,
            id: this.props.data.id,
            arrow: [],
            lazyloadNext: this.props.lazyloadNext ? this.props.lazyloadNext : 1,
            leftArrowActive: false,
            rightArrowActive: true,
            refresh:0,
            touchStart: null,
            touchEnd: null,
            updating: false,
            loading: true,
        };
    }
    
    componentDidMount(){ 
        var $parent = this;
        setTimeout(function($parent){
            $parent.setArrows();
        },0,$parent);
        
        document.addEventListener("SearchSorting_viewSwitch", this.refreshSlideshow);
        document.addEventListener("CheckWindowResize", this.refreshSlideshow)

        this.setState({
            loading: false
        });
    }
    
    componentDidUpdate(){ 
        var needsRefresh = 0;
        
        if(this.props.images[0] && this.state.originalImages[0].src !== this.props.images[0].src){
            needsRefresh++;
        } 
        
        if(this.props.id !== this.state.id){
            needsRefresh++;
        }
        
        if(needsRefresh > 0){ 
            this.refreshSlideshow();
        }
    }
    
    checkArrows = (params) => { 
        var max = this.state.images.length-1,
            newIndex = this.getNewIndex(params.direction);

        if(newIndex < 0) newIndex = max;
        else if(newIndex > max) newIndex = 0;
        
        if(newIndex > 0){ 
            this.state.arrows[0].style.display = 'block';
            this.setState({
                leftArrowActive: true
            });
        } else if(!this.state.images[this.state.images.length-1].loaded){ 
            this.state.arrows[0].style.display = 'none';
            this.setState({
                leftArrowActive: false
            });
        }

        if(newIndex < (this.state.images.length-1)){ 
            this.state.arrows[1].style.display = 'block';
            this.setState({
                rightArrowActive: true
            });
        }
        
        const $parent = this;
        
        setTimeout(function(params){
            params.$parent.lazyLoad(
                {
                    direction: params.direction, 
                    current: params.current,
                    max: params.max
                }
            );
        },500,
        {
            $parent: $parent,
            direction: params.direction, 
            current: newIndex,
            max:max 
        });
        
    }
    
    setArrows(){
        var parentWidth = this.slideshowRef.current.imageContainer.offsetParent.getBoundingClientRect().width;

        if(this.slideshowRef.current.allImages[0].offsetWidth !== parentWidth){
            this.slideshowRef.current.imageContainer.offsetParent.style.width = this.slideshowRef.current.allImages[0].offsetWidth+'px';
        }

        var arrows = this.containerRef.current.querySelectorAll('.nav');
        this.setState({
            arrows: arrows
        });

        if(this.state.images.length === 1 || !this.state.images[this.state.images.length-1].loaded){
            arrows[0].style.display = 'none';
        }
        
        if(this.state.images.length === 1){ 
            arrows[1].style.display = 'none';
            this.setState({
                rightArrowActive: false
            });
        }
        
        var $parent = this;
        
        this.checkArrowsPrev = function(e){
            if($parent.props.mobile) e.preventDefault();

            $parent.checkArrows({
                direction: 'prev'
            });
        };
        
        this.checkArrowsNext = function(e){ 
            if($parent.props.mobile) e.preventDefault();

            $parent.checkArrows({
                direction: 'next'
            });
        };
        
        arrows[0].addEventListener('click', this.checkArrowsPrev);
        arrows[1].addEventListener('click', this.checkArrowsNext);
    }
    
    getNewIndex = (direction) => {
        var newIndex = direction === 'prev' ? this.state.current-1 : this.state.current+1;
        
        this.setState({
            current: newIndex
        });
        
        return newIndex;
    }
    
    images = () => {
        var images = [],
            preloadCount = this.props.preloadCount ? this.props.preloadCount : 1;
        
        for(var i = 0; i < this.props.images.length; i++){
            images.push({
                src: i < preloadCount ? this.props.images[i].src : this.props.images[0].src,
                lazy: this.props.images[i].src,
                link: this.props.images[i].link,
                style: {
                    'backgroundImage': i < preloadCount ? `url(${this.props.images[i].src})` : 'none',
                    'opacity': i < preloadCount ? '1' :'0',
                    'backgroundRepeat': 'no-repeat',
                },
                loadingStyle: {
                    'opacity': i < preloadCount ? '0' :'1'
                },
                loaded: i < preloadCount ? true : false
            });
        } 
        
        return images;
    }
    
    lazyLoad = (params) => {
        var leftToLoad = this.state.lazyloadNext,
            images = this.state.images;
        
        for(var i = 0; i < this.state.images.length; i++){
            if(!this.state.images[i].loaded && leftToLoad > 0){
                images[i].src = this.state.images[i].lazy;
                images[i].style = {
                    'backgroundImage': `url(${this.state.images[i].lazy})`,
                    'opacity': '1',
                    'backgroundRepeat': 'no-repeat'
                };
                images[i].loadingStyle = {
                    'opacity': '0'
                };
                images[i].loaded = true;

                const fetchingImage = (
                    <img 
                        src={this.state.images[i].lazy} 
                        onLoad={this.setState({images:images})}  
                        alt="photo"
                    />
                );                
                
                leftToLoad--;
            }
        }
    }
    
    onTouchStart = (evt) => { 
        this.setState({
            touchStart: evt.touches[0].clientX,
            touchEnd: null
        });
        this.istouching = true;
    }
    
    onTouchMove = (evt) => { 
        if(this.istouching){
                this.setState({
                touchEnd: evt.touches[0].clientX
            });
        }
    }
        
    onTouchEnd = (evt) => {
        if(this.state.touchEnd){
            var direction = this.state.touchStart > this.state.touchEnd ? 'next' : 'prev';
            
            if(this.state.current === 0 && !this.state.images[this.state.images.length-1].loaded && direction === 'prev'){ 
                //forbidden
                return;
            }
            
            if(direction === 'next' && this.state.rightArrowActive){
                this.slideshowRef.current.goNext();
            } else if(direction === 'prev' && this.state.leftArrowActive){
                this.slideshowRef.current.goBack();
            }

            this.checkArrows(
                {
                    direction: direction
                }
            );
        }
        
        this.istouching = false;
    }
    
    refreshSlideshow = () => {
        if(this.state.updating) return;
    
        if(!this.slideshowRef || this.slideshowRef && !this.slideshowRef.current){
            setTimeout(this.refreshSlideshow, 100);
            return;
        }
        
        var refresh = this.state.refresh+1;
        
        this.setState({
            refresh: refresh,
            updating: true
        }, () => {
            this.slideshowRef.current.goTo(0);
            
            this.setState({
                originalImages: this.props.images, 
                images: this.images(),
                current: 0,
                id: this.props.id
            }, () => {
                this.setState({
                    updating: false
                });
            });

            this.setArrows();
        });
    }
    onClick = () => {
        if (this.props.sendClickEvent) {
            this.props.sendClickEvent();
        }
        window.open(this.state.images[0].link.replace('http:', ''), '_blank');
    }
    render(){
        let firstImage = this.state.images[0];
        return (
            this.state.loading ?
            <div className="each-slide">
                <div className="transition-1 bg-grey3 width-100">
                    <a href={firstImage.link} className="inline-block width-100">
                    <div className="width-100">
                        <img
                            style={{'width': 'calc( 100% + 15px )'}}
                            src={firstImage.src}
                            alt="photo"
                        />
                    </div>
                    </a>
                </div>
            </div>
            :
            <div className="slide-container z-index-0" ref={this.containerRef} key={this.props.data.id+'-'+this.state.refresh}>
                    
                    <Slide
                        ref={this.slideshowRef}
                        key="slideshow"
                        transitionDuration={500}
                        infinite={true}
                        indicators={false}
                        arrows={true}
                        autoplay={false}
                        onTouchStart={this.onTouchStart}
                        onTouchMove={this.onTouchMove}
                        onTouchEnd={this.onTouchEnd}
                        onChange={(oldIndex, newIndex) => { this.props.onImageChange(newIndex) }}
                    >
                        {this.state.images.map((item, index) => {
                            return <div className="each-slide" key={index}>
                                <SlideContainer className="transition-1 bg-grey3 width-100"  onClick={this.onClick}>
                                    <Image src={item.src}  width="425" height="285"   className="" alt="photo" />
                                </SlideContainer>
                            </div>
                            })
                        }
                    </Slide>
            </div>
        )
    }
}